module.exports = __webpack_public_path__ + "img/header.8535f0ee.jpg";